/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */

/* eslint-disable react/no-unused-prop-types */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Fragment, useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { connect } from 'react-redux';
import { Networks, GOOGLE_SUPPORT_BILLING_LINK } from 'AdsUI/lib/Constants';
import UITabs from 'UIComponents/nav/UITabs';
import UITab from 'UIComponents/nav/UITab';
import UIHeader from 'UIComponents/layout/UIHeader';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { hasAccessToEvents, hasAdvancedAdWordsAccess } from 'AdsUI/selectors/AuthSelectors';
import { isAdWordsAccountConnected, isAnyAccountConnected, getAdAccounts } from 'AdsUI/selectors/AccountsSelectors';
import HeaderBannerContainer from 'AdsUI/containers/banners/HeaderBannerContainer';
import HeaderCreationContainer from 'AdsUI/containers/HeaderCreationContainer';
import I18n from 'I18n';
import { withRouterLite } from '../lib/withRouterLite';
import SmokeAlarm from 'AdsUI/containers/banners/SmokeAlarm';
const ADS_OFFLINE_EVENTS_V2_KEY = 'ads-offline-events-v2';

const AdswordsBillingBanner = ({
  onClose
}) => /*#__PURE__*/_jsx(UIAlert, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "adwordsBillingNotSetupBanner.status"
  }),
  type: "danger",
  closeable: true,
  onClose: onClose,
  children: /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "adwordsBillingNotSetupBanner.note"
    }), ' ', /*#__PURE__*/_jsx(UILink, {
      href: GOOGLE_SUPPORT_BILLING_LINK,
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "adwordsBillingNotSetupBanner.action"
      })
    })]
  })
});

const DashboardNavigation = ({
  activeItem,
  adWordsAccountConnected,
  anyAccountConnected,
  headerBanners,
  hasAdvancedSettings,
  history,
  hasEvents,
  adAccounts
}) => {
  const [showAdwordsBillingBanner, setShowAdwordsBillingBanner] = useState(true);
  const {
    openUpgradeModal
  } = useUpgradeModal(ADS_OFFLINE_EVENTS_V2_KEY);
  const shouldRenderAdvancedSettingsTab = hasAdvancedSettings && adWordsAccountConnected;
  const shouldRenderAlert = headerBanners && !headerBanners.isEmpty();
  const navigate = useCallback(e => {
    if (e.target.value === 'events' && !hasEvents) {
      openUpgradeModal();
      return;
    }

    history.push(e.target.value);
  }, [history, hasEvents, openUpgradeModal]);
  const isAdwordsBillingError = !!adAccounts.find(account => account.network === Networks.ADWORDS && account.paymentMethodIsMissing);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(UIHeader, {
      "data-test-id": "dashboard-tabs",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ads"
      }),
      use: "condensed",
      fullWidth: true,
      flush: true,
      tabs: /*#__PURE__*/_jsxs(UITabs, {
        selected: activeItem,
        onSelectedChange: navigate,
        children: [/*#__PURE__*/_jsx(UITab, {
          tabId: "/",
          title: I18n.text('manage')
        }), /*#__PURE__*/_jsx(UITab, {
          tabId: "audiences",
          title: I18n.text('audiences.title')
        }), /*#__PURE__*/_jsx(UITab, {
          tabId: "events",
          "data-test-id": "events-button",
          title: /*#__PURE__*/_jsxs(Fragment, {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "events.title"
            }), !hasEvents && /*#__PURE__*/_jsx(UILockBadge, {
              className: "m-left-2"
            })]
          })
        }), /*#__PURE__*/_jsx(UITab, {
          tabId: "dashboard",
          "data-test-id": "analyze-button",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "analyze"
          })
        }), shouldRenderAdvancedSettingsTab && /*#__PURE__*/_jsx(UITab, {
          tabId: "advanced-settings",
          title: I18n.text('advancedSettings')
        })]
      }),
      alert: shouldRenderAlert ? /*#__PURE__*/_jsx(HeaderBannerContainer, {}) : isAdwordsBillingError && showAdwordsBillingBanner ? /*#__PURE__*/_jsx(AdswordsBillingBanner, {
        onClose: () => setShowAdwordsBillingBanner(false)
      }) : undefined,
      children: [anyAccountConnected && /*#__PURE__*/_jsx(HeaderCreationContainer, {
        hasEvents: hasEvents
      }), /*#__PURE__*/_jsx(SmokeAlarm, {})]
    })
  });
};

DashboardNavigation.propTypes = {
  activeItem: PropTypes.string,
  children: PropTypes.node
};
export default connect(state => ({
  adAccounts: getAdAccounts(state),
  adWordsAccountConnected: isAdWordsAccountConnected(state),
  anyAccountConnected: isAnyAccountConnected(state),
  headerBanners: state.banners.header.banners,
  hasAdvancedSettings: hasAdvancedAdWordsAccess(state),
  hasEvents: hasAccessToEvents(state)
}))(withRouterLite(DashboardNavigation));